import React, { useEffect, useState } from "react";
import apiClient from "../services/apiClient";

const BookmarksPage = ({ storyId }) => {
  const [bookmarks, setBookmarks] = useState([]);

  useEffect(() => {
    apiClient.get(`/api/v1/bookmarks?story_id=${storyId}`)
      .then((response) => setBookmarks(response.data))
      .catch((error) => console.error("Error fetching bookmarks:", error));
  }, [storyId]);

  return (
    <div>
      <h1>Bookmarks</h1>
      <ul>
        {bookmarks.map((bookmark) => (
          <li key={bookmark.id}>
            Chapter {bookmark.chapter_id} at {bookmark.position}%
          </li>
        ))}
      </ul>
    </div>
  );
};

export default BookmarksPage;